<template>
  <div class="animated fadeIn">
    <InvoiceFilters
      :filters="filters"
      :commercials="commercials"
      :zipcodes="zipcodes"
      :invoiceSeries="invoiceSeries"
      stats
      @load="(form) => loadInvoices(form)"
    />

    <div class="card card-inverse card-info text-center" v-if="isLoading">
      <div class="card-block">
        <blockquote class="card-blockquote">Chargement en cours ...</blockquote>
      </div>
    </div>

    <ConversionCard
      v-if="!isLoading"
      :commercials="filters.commercials"
      :orders="orders"
      :selectedDepartments="filters.zipcodes"
      :departments="zipcodes"
    />
  </div>
</template>

<script>
import InvoiceFilters from "@/components/invoice/InvoiceFilters";
import ConversionCard from "@/components/stats/ConversionCard";

import { mapState, mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {
    InvoiceFilters,
    ConversionCard,
  },

  data() {
    return {
      isLoading: false,
      orders: [],
      commercials: [],
      filters: {
        begin: moment().startOf("month").startOf("day").format("YYYY-MM-DD"),
        end: moment().endOf("month").startOf("day").format("YYYY-MM-DD"),
        concept: [],
        invoiceSerieCode: null,
        client: null,
        type: null,
        zipcodes: [{ label: "Tous", value: "all" }],
        commercials: [],
      },
    };
  },

  async created() {
    await this.getCommercials();

    const currentCommercial = this.commercials.find((c) => {
      if (this.$store.state.user.email === c.value) {
        return c;
      }
    });

    if (currentCommercial) {
      this.filters.commercials.push(currentCommercial);
    }

    await this.loadInvoices();
  },

  computed: {
    ...mapState({
      invoiceSeries: (state) => state.invoiceSeries,
    }),

    ...mapGetters({
      departments: "getDepartments",
    }),

    zipcodes() {
      return this.departments.map(({ code, name }) => {
        if (code === "all") {
          return { label: name, value: code };
        } else {
          return { label: code + " - " + name, value: code };
        }
      });
    },
  },

  methods: {
    async loadInvoices(form) {
      try {
        this.isLoading = true;

        if (form) {
          this.filters = form;
        }

        let zipcodes = null;

        if (this.filters.zipcodes?.length > 0) {
          const values = this.filters.zipcodes.map(({ value }) => value);

          if (!values.includes("all")) {
            zipcodes = values;
          }
        }

        const { data } = await this.$api.get(`/invoices/for-stats`, {
          params: {
            begin: this.filters.begin,
            end: this.filters.end,
            concept: this.filters.concept,
            merchantId: this.filters.merchant
              ? this.filters.merchant.value
              : null,
            invoiceSerieCode: this.filters.invoiceSerieCode,
            client: this.filters.client ? this.filters.client.value : null,

            match: this.filters.match,
            type: this.filters.type ? this.filters.type.value : null,
            zipcodes: zipcodes,
            commercials:
              this.filters.commercials &&
              this.filters.commercials.map((c) => c.value),
          },
        });

        this.orders = data;
      } catch (e) {
        this.$errorToast("Erreur lors du chargement des données");
      } finally {
        this.isLoading = false;
      }
    },

    async getCommercials() {
      try {
        const { data } = await this.$api.get("/users/commercials/search");

        this.commercials = data.map((c) => ({
          value: c.email,
          label: c.commercial.pseudo,
          color: c.commercial?.color,
        }));
      } catch (e) {
        this.$errorToast("Impossible de charger les commerciaux");
      }
    },
  },
};
</script>
